import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (
    route,
    state
) => {
    const router: Router = inject(Router);
    const authService = inject(AuthService);

    // Coupa SSO must replace a stale local session, not redirect to home.
    if (
        state.url.includes('login/coupa') &&
        AuthUtils.hasCoupaLoginParams(state.url)
    ) {
        return of(true);
    }

    return authService.check().pipe(
        switchMap(authenticated => {
            if (authenticated) {
                return of(router.parseUrl('/home'));
            }
            return of(true);
        })
    );
};
